export default "__VITE_ASSET__5a21a714__"